export default __webpack_public_path__ + "static/media/bsLogo.4e7846da.png";